import {useMemo, useState} from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import BackDrop from "../../../global/BackDrop";
import { 
  eliminarEscalaVuelosAction, 
  eliminarEscalaVuelosRegresoAction, 
  obtenerEscalasVueloAction, 
  obtenerEscalasVueloRegresoAction, 
} from "../../../ducks/proveedorAereolineaDuck";

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})

const TablaEscalasVuelos = ({ tipo }) => {
  const { vueloTarget } = useSelector((state) => state.proveedorTerrestre);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isLoad, setIsLoad] = useState(false);
  const { escalasVuelo, escalasVueloRegreso } = useSelector(store => store.vueloProveedor);

  const rows = useMemo(() => {
    const escalas = tipo === "ida" 
      ? escalasVuelo ?? [] 
      : escalasVueloRegreso ?? []
    return escalas
  },[escalasVuelo, escalasVueloRegreso, tipo]);

  const onDelete = async (escala) => {
    const result = await DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminarlo',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    });
  
    if (result.isConfirmed) {
      setIsLoad(true);
      try {
        // Eliminar destino
        const payload = {
          idVueloProveedorEscala: escala?.IdVueloProveedorEscala,
        }

        const regresoPayload = {
          idVueloRedondoEscala: escala?.IdVueloRedondoEscala,
        }

        const dispatchDeleteAction = tipo === "regreso" 
          ? eliminarEscalaVuelosRegresoAction
          : eliminarEscalaVuelosAction;

        const deletePayload = tipo === "regreso" ? regresoPayload : payload;

        const response = await dispatch(dispatchDeleteAction(deletePayload));
        
        if (response?.status === 200) {
          ToastMessage.fire('¡Eliminado!', 'La escala ha sido eliminada.', 'success');
        }

        const getPayload = tipo === "regreso" 
          ? { idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo }
          : { idVueloProveedor: vueloTarget?.IdVueloProveedor }

          const getDispatchAction = tipo === "regreso" 
            ? obtenerEscalasVueloRegresoAction
            : obtenerEscalasVueloAction;

        // Obtener lista actualizada
        await dispatch(getDispatchAction(getPayload));

      } catch (error) {
        ToastMessage.fire('Error', 'No se pudo eliminar la escala.', 'error');
      } finally {
        setIsLoad(false);
      }
    } else {
      ToastMessage.fire('Cancelado', 'No se ha realizado ningún cambio.', 'info');
    }
  };
  
  return (
    <>
      <TableContainer component={Paper} className={classes.container}>
        <Table size="small" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="left" key="escala">Escalas</TableCell>
              <TableCell align="center" key="acciones"></TableCell>
            </TableRow>
          </TableHead>
          
          <TableBody>
            {rows && rows.length > 0 ? rows.map((escala) => (
              <TableRow key={escala.IdPaqueteProveedorTerrestreCiudad}>
                <TableCell align="left">{`${escala.CodigoIATA?.Nombre} - ${escala.CodigoIATA?.Descripcion}`}</TableCell>
                <TableCell align="center">
                  <ButtonGroup
                    color="primary"
                    size="small"
                    aria-label="small outlined  button group"
                  >
                    <Button onClick={() => {onDelete(escala)}}>
                      Eliminar
                    </Button>
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell colSpan={6}>No hay escalas registradas</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <BackDrop open={isLoad}/>
    </>
  );
};
export default TablaEscalasVuelos;
